// Wrap everything in DOM ready to ensure elements exist before initialization
jQuery(document).ready(function ($) {

    /*----------  scrolltop  ----------*/
    $('body').materialScrollTop();

    /*----------  animate.css on scroll ----------*/
    new WOW().init();

    /*---------- full image popups ----------*/
    // $(document).ready(function() {
    //    $('.lightbox').magnificPopup({type:'image'});
    // });

    /*----------  Slider Hero ----------*/
    (function () {
        const hooklines = document.querySelectorAll('.hookline-item');
        let currentIndex = 0;
        const displayDuration = 4000;
        const fadeOutDuration = 1200;

        if (hooklines.length === 0) return;

        // Wrap each word and character in spans for proper wrapping
        function wrapCharacters(element) {
            const text = element.textContent.trim();
            if (!text) return;

            element.innerHTML = '';

            // Split into words
            const words = text.split(' ');
            let charIndex = 0;

            words.forEach((word, wordIndex) => {
                const wordSpan = document.createElement('span');
                wordSpan.className = 'word';
                wordSpan.style.display = 'inline-block';
                wordSpan.style.whiteSpace = 'nowrap';

                // Wrap each character in the word
                word.split('').forEach((char) => {
                    const span = document.createElement('span');
                    span.className = 'char';
                    span.textContent = char;
                    span.style.display = 'inline-block';
                    span.style.opacity = '0';
                    span.setAttribute('data-index', charIndex);
                    charIndex++;
                    wordSpan.appendChild(span);
                });

                element.appendChild(wordSpan);

                // Add space after word (except last word)
                if (wordIndex < words.length - 1) {
                    const space = document.createElement('span');
                    space.className = 'space';
                    space.textContent = '\u00A0';
                    space.style.display = 'inline-block';
                    element.appendChild(space);
                }
            });
        }

        // Animate characters in
        function animateIn(element) {
            const chars = element.querySelectorAll('.char');
            chars.forEach((char) => {
                const index = parseInt(char.getAttribute('data-index'));
                setTimeout(() => {
                    char.style.transition = 'all 0.6s ease-out';
                    char.style.opacity = '1';
                    char.style.transform = 'translateY(0px) scale(1)';
                    char.style.filter = 'blur(0px)';
                }, index * 20);
            });
        }

        // Animate characters out with dissolve effect
        function animateOut(element, callback) {
            const chars = element.querySelectorAll('.char');
            const totalDuration = fadeOutDuration;

            chars.forEach((char) => {
                const index = parseInt(char.getAttribute('data-index'));
                setTimeout(() => {
                    char.style.transition = 'all 1.2s ease-out';
                    char.style.opacity = '0';
                    char.style.transform = 'translateY(30px) scale(0.8)';
                    char.style.filter = 'blur(8px)';
                }, index * 15);
            });

            // Call callback when animation is done
            setTimeout(callback, totalDuration);
        }

        // Initialize all hooklines
        hooklines.forEach((hookline, index) => {
            hookline.style.position = 'relative';
            hookline.style.width = '100%';
            hookline.style.left = '0';
            hookline.style.top = '0';
            hookline.style.opacity = '1';
            hookline.style.transform = 'none';
            wrapCharacters(hookline);

            if (index !== 0) {
                hookline.style.display = 'none';
            }
        });

        function showNextHookline() {
            const currentItem = hooklines[currentIndex];

            // Show and animate in
            currentItem.style.display = 'block';
            animateIn(currentItem);

            // Schedule exit animation
            setTimeout(() => {
                animateOut(currentItem, () => {
                    // Hide after animation completes
                    currentItem.style.display = 'none';

                    // Move to next
                    currentIndex = (currentIndex + 1) % hooklines.length;
                    showNextHookline();
                });
            }, displayDuration);
        }

        // Start the animation when page loads
        showNextHookline();
    })();

    /*----------  Slider News ----------*/
    if ($('#news-slider').length) {
        jQuery('#news-slider').slick({
            autoplay: true,
            autoplaySpeed: 3850,
            dots: true,
            fade: false,
            arrows: false,
            infinite: true,
            speed: 1600,
            slidesToShow: 4,
            slidesToScroll: 4,
            adaptiveHeight: false,
            vertical: false,
            centerMode: false,
            variableWidth: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        adaptiveHeight: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    }

    /*----------  Slider Bilder ----------*/
    if ($('#slider-img').length) {
        jQuery('#slider-img').slick({
            autoplay: true,
            autoplaySpeed: 3850,
            dots: true,
            fade: false,
            arrows: false,
            infinite: true,
            speed: 1600,
            slidesToShow: 3,
            slidesToScroll: 3,
            adaptiveHeight: false,
            vertical: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        fade: true,
                        adaptiveHeight: true
                    }
                }
            ]
        });
    }

    // When the user scrolls down 80px from the top of the document, resize the navbar's padding and the logo's font size
    window.onscroll = function () { scrollFunction() };

    function scrollFunction() {
        if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
            $('.header-main').addClass('scrolled');
            $('.infobar').slideUp(200);
        } else {
            $('.header-main').removeClass('scrolled');
            $('.infobar').slideDown(200);
        }
    }

    /*----------  Homepage Counter (empirica in Zahlen)  ----------*/
    if ($('.counter').length) {
        // Initialize the new reliable counter animation
        window.initCounters('.counter', {
            duration: 2500,        // 2.5 seconds animation
            separator: ',',        // Use comma as decimal separator (German format)
            thousandsSeparator: '.' // Use dot as thousands separator (German format)
        });
    }

    /*---------- lange Elemente kürzen ----------*/
    if ($('.shorten').length) {
        $('.shorten').contenttoggle({
            collapsedHeight: 400,
            collapseText: 'verkürzt anzeigen',
            expandText: 'komplett anzeigen'
        });
    }

    /*---------- clear input button ----------*/
    if ($("#keywords").length && $("#clearButton").length) {
        const textInput = $("#keywords");
        const clearButton = $("#clearButton");

        // Function to toggle the clear button visibility
        function toggleClearButton() {
            if (textInput.val()) {
                clearButton.removeClass("d-none");
            } else {
                clearButton.addClass("d-none");
            }
        }

        // Check the input field state on page load
        toggleClearButton();

        // Show/hide clear button based on input value
        textInput.on("input", function () {
            toggleClearButton();
        });

        // Clear input on button click
        clearButton.on("click", function () {
            textInput.val("");
            toggleClearButton(); // Update button visibility after clearing
            textInput.focus(); // Focus back on the input
        });
    }

    /*----------  Desktop navbar: dropdown on hover ----------*/
    var hoverTimeout;
    $('.navbar-main .dropdown').on('mouseenter', function () {
        clearTimeout(hoverTimeout);
        var $this = $(this);
        $('.navbar-main .dropdown').not($this).removeClass('show').find('.dropdown-menu').removeClass('show');
        $this.addClass('show').find('.dropdown-menu').addClass('show');
    }).on('mouseleave', function () {
        var $this = $(this);
        hoverTimeout = setTimeout(function () {
            $this.removeClass('show').find('.dropdown-menu').removeClass('show');
        }, 200);
    });

    /*----------  Publication toggle (truncateText) ----------*/
    $('#publications').on('click', '.read-more, .read-less', function (e) {
        e.preventDefault();
        var $wrapper = $(this).closest('.publication-toggle');
        $wrapper.find('.publication-preview, .publication-full').toggle();
    });

}); // End of jQuery(document).ready()

